$(document).ready(function() {
$(".side-menu-header--close").on("click", function () {
    setTimeout(function () {
      var $toggleNav = $(".toggle-mob-nav");
  
      if ($toggleNav.length && !$toggleNav.is(":focus")) {
        $toggleNav.attr("tabindex", 0).focus();
      }
    }, 300);
  });
});




$(document).ready(function() {

    document.addEventListener('DOMContentLoaded', function () {
        const imageElement = document.getElementById('ellhp');
        if (imageElement) {
          imageElement.remove();
        }
      });

    $('.pretty-select.id-sort-by .text').remove();

       $('.splide__slide.is-visible').removeAttr('role');
  
    $("br").attr("aria-hidden", "true");
    $('a').each(function () {
        // Check if the link is external
        if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://www.playgosports.com/') {
          // Create a span element with warning text
          var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
          // Set attributes for accessibility
          $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
          // Append the warning span inside the link
          $(this).append(warningSpan);
        }
      });

});



// $(document).ready(function() {
//     // Create an interval to check for the image every 500 milliseconds
//     var checkImage = setInterval(function() {
//         var image = $(".shipsell-img-wrapper img");
        
//         // If the image is found, assign the alt attribute and clear the interval
//         if (image.length) {
//             image.attr("alt", "Truck icon for free shipping offer");
//             clearInterval(checkImage); // Stop checking once the image is found and alt is assigned
//         }
//     }, 500); // Check every 500ms (can adjust the interval as needed)
// });

// $(document).ready(function () {
//     // Handle click events on the main dropdown button (link)
//     $('.main-nav').on('click', '.nav-item.dropdown > .nav-item-link', function (evt) {
//         evt.preventDefault(); // Prevent default anchor behavior
//         var $dropdownContainer = $(this).parent(); // Get parent .nav-item
//         toggleDropdown($dropdownContainer);
//     });

//     // Handle click events on the submenu items
//     $('.main-nav').on('click', '.sub-nav-item > .sub-nav-item-link', function (evt) {
//         // Allow the link to follow its href, no preventDefault
//     });

//     // Handle click events specifically on the SVG icon to toggle dropdown
//     $('.main-nav').on('click', '.nav-item.dropdown .svg-chevron-down', function (evt) {
//         evt.preventDefault(); // Prevent default behavior on the SVG icon
//         var $dropdownContainer = $(this).closest('.nav-item.dropdown'); // Get parent .nav-item.dropdown
//         toggleDropdown($dropdownContainer); // Call the toggle function
//     });

//     // Handle focus events for accessibility on submenu items
//     $('.main-nav').on('focus', '.sub-nav-item > .sub-nav-item-link', function () {
//         var $submenuContainer = $(this).parent(); // Get parent .sub-nav-item
//         toggleSubDropdown($submenuContainer);
//     });

//     // Keyboard event for space key and enter key on main dropdown and submenu items
//     $('.main-nav').on('keydown', '.nav-item.dropdown > .nav-item-link, .sub-nav-item > .sub-nav-item-link', function (evt) {
//         if (evt.which === 32 || evt.which === 13) { // Space (32) or Enter (13) key
//             evt.preventDefault(); // Prevent default action
//             $(this).click(); // Simulate click event
//         }
//     });

//     // Function to toggle the main dropdown
//     function toggleDropdown($dropdownContainer) {
//         var isOpen = $dropdownContainer.hasClass('open'); // Check if it's already open

//         // Close all open dropdowns except the clicked one
//         $('.nav-item.dropdown').not($dropdownContainer).removeClass('open')
//             .children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();

//         // Toggle current dropdown
//         if (isOpen) {
//             $dropdownContainer.removeClass('open');
//             $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();
//         } else {
//             $dropdownContainer.addClass('open');
//             $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'true').next('.sub-nav').show();
//             // Move focus to the first item in the submenu
//             $dropdownContainer.find('.sub-nav-item-link').first().focus();
//         }
//     }

//     // Function to toggle the submenu
//     function toggleSubDropdown($submenuContainer) {
//         var isOpen = $submenuContainer.hasClass('open'); // Check if it's already open

//         // Toggle current submenu
//         if (isOpen) {
//             $submenuContainer.removeClass('open');
//             $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'false');
//             $submenuContainer.find('.sub-sub-nav-list').hide(); // Hide submenu
//         } else {
//             $submenuContainer.addClass('open');
//             $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'true');
//             $submenuContainer.find('.sub-sub-nav-list').show(); // Show submenu
//             // Move focus to the first item in the submenu
//             $submenuContainer.find('.sub-sub-nav-list a').first().focus();
//         }
//     }
// });






// // good menu js
// $(document).ready(function () {
//     // Create an interval to check for the image every 500 milliseconds
//     var checkImage = setInterval(function () {
//         var image = $(".shipsell-img-wrapper img");

//         // If the image is found, assign the alt attribute and clear the interval
//         if (image.length) {
//             image.attr("alt", "Truck icon for free shipping offer");
//             clearInterval(checkImage); // Stop checking once the image is found and alt is assigned
//         }
//     }, 500); // Check every 500ms (can adjust the interval as needed)

//     // Handle click events on the main dropdown button (link)
//     $('.main-nav').on('click', '.nav-item.dropdown > .nav-item-link', function (evt) {
//         evt.preventDefault(); // Prevent default anchor behavior
//         var $dropdownContainer = $(this).parent(); // Get parent .nav-item
//         toggleDropdown($dropdownContainer);
//     });

//     // Handle click events on the submenu items
//     $('.main-nav').on('click', '.sub-nav-item > .sub-nav-item-link', function (evt) {
//         var $submenuContainer = $(this).parent(); // Get parent .sub-nav-item
//         if ($submenuContainer.find('.sub-sub-nav-list').length) {
//             evt.preventDefault(); // Prevent navigation if it is a dropdown
//             toggleSubDropdown($submenuContainer); // Toggle the submenu
//         } else {
//             // If there's no submenu, allow navigation to the link
//             window.location.href = $(this).attr('href');
//         }
//     });

//     // Handle click events specifically on the SVG icon to toggle dropdown
//     $('.main-nav').on('click', '.nav-item.dropdown .svg-chevron-down', function (evt) {
//         evt.preventDefault(); // Prevent default behavior on the SVG icon
//         var $dropdownContainer = $(this).closest('.nav-item.dropdown'); // Get parent .nav-item.dropdown
//         toggleDropdown($dropdownContainer); // Call the toggle function
//     });

//     // Handle focus events for accessibility on submenu items
//     $('.main-nav').on('focus', '.sub-nav-item > .sub-nav-item-link', function () {
//         var $submenuContainer = $(this).parent(); // Get parent .sub-nav-item
//         // Do not toggle on focus
//     });

//     // Keyboard event for space key and enter key on main dropdown and submenu items
//     $('.main-nav').on('keydown', '.nav-item.dropdown > .nav-item-link, .sub-nav-item > .sub-nav-item-link', function (evt) {
//         if (evt.which === 32 || evt.which === 13) { // Space (32) or Enter (13) key
//             evt.preventDefault(); // Prevent default action
//             $(this).click(); // Simulate click event
//         }
//     });

//     // Function to toggle the main dropdown
//     function toggleDropdown($dropdownContainer) {
//         var isOpen = $dropdownContainer.hasClass('open'); // Check if it's already open

//         // Close all open dropdowns except the clicked one
//         $('.nav-item.dropdown').not($dropdownContainer).removeClass('open')
//             .children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();

//         // Toggle current dropdown
//         if (isOpen) {
//             $dropdownContainer.removeClass('open');
//             $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();
//         } else {
//             $dropdownContainer.addClass('open');
//             $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'true').next('.sub-nav').show();
//             // Move focus to the first item in the submenu
//             $dropdownContainer.find('.sub-nav-item-link').first().focus();
//         }
//     }

//     // Function to toggle the submenu
//     function toggleSubDropdown($submenuContainer) {
//         var isOpen = $submenuContainer.hasClass('open'); // Check if it's already open

//         // Toggle current submenu
//         if (isOpen) {
//             $submenuContainer.removeClass('open');
//             $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'false');
//             $submenuContainer.find('.sub-sub-nav-list').hide(); // Hide submenu
//         } else {
//             $submenuContainer.addClass('open');
//             $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'true');
//             $submenuContainer.find('.sub-sub-nav-list').show(); // Show submenu
//             // Move focus to the first item in the submenu
//             $submenuContainer.find('.sub-sub-nav-list a').first().focus();
//         }
//     }
// });




// query before autoclose inner submenu
// $(document).ready(function () {
//     // Check for the image and assign alt text
//     var checkImage = setInterval(function () {
//         var image = $(".shipsell-img-wrapper img");
//         if (image.length) {
//             image.attr("alt", "");
//             clearInterval(checkImage);
//         }
//     }, 500);

//     // Handle main dropdown toggle click
//     $('.main-nav').on('click', '.nav-item.dropdown > .nav-item-link', function (evt) {
//         evt.preventDefault();
//         var $dropdownContainer = $(this).parent();
//         toggleDropdown($dropdownContainer);
//     });

//     // Handle submenu item toggle click
//     $('.main-nav').on('click', '.sub-nav-item > .sub-nav-item-link', function (evt) {
//         var $submenuContainer = $(this).parent();
//         if ($submenuContainer.find('.sub-sub-nav-list').length) {
//             evt.preventDefault();
//             toggleSubDropdown($submenuContainer);
//         } else {
//             window.location.href = $(this).attr('href');
//         }
//     });

//     // Handle icon click to toggle main dropdown
//     $('.main-nav').on('click', '.nav-item.dropdown .svg-chevron-down', function (evt) {
//         evt.preventDefault();
//         var $dropdownContainer = $(this).closest('.nav-item.dropdown');
//         toggleDropdown($dropdownContainer);
//     });

//     // Keyboard navigation for dropdowns
//     $('.main-nav').on('keydown', '.nav-item.dropdown > .nav-item-link, .sub-nav-item > .sub-nav-item-link', function (evt) {
//         if (evt.which === 32 || evt.which === 13) {
//             evt.preventDefault();
//             $(this).click();
//         }
//     });

//     // Toggle main dropdown
//     function toggleDropdown($dropdownContainer) {
//         var isOpen = $dropdownContainer.hasClass('open');

//         // Close other open dropdowns
//         $('.nav-item.dropdown').not($dropdownContainer).removeClass('open')
//             .children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();

//         if (isOpen) {
//             closeDropdown($dropdownContainer);
//         } else {
//             openDropdown($dropdownContainer);
//         }
//     }

//     function openDropdown($dropdownContainer) {
//         $dropdownContainer.addClass('open');
//         $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'true').next('.sub-nav').show();
//     }

//     function closeDropdown($dropdownContainer) {
//         $dropdownContainer.removeClass('open');
//         $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();
//     }

//     // Toggle submenu dropdown
//     function toggleSubDropdown($submenuContainer) {
//         var isOpen = $submenuContainer.hasClass('open');
//         if (isOpen) {
//             closeSubDropdown($submenuContainer);
//         } else {
//             openSubDropdown($submenuContainer);
//         }
//     }

//     function openSubDropdown($submenuContainer) {
//         $submenuContainer.addClass('open');
//         $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'true');
//         $submenuContainer.find('.sub-sub-nav-list').show();
//     }

//     function closeSubDropdown($submenuContainer) {
//         $submenuContainer.removeClass('open');
//         $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'false');
//         $submenuContainer.find('.sub-sub-nav-list').hide();
//     }

//     // Close dropdowns on Escape key, retaining proper state
//     $(document).on('keydown', function (evt) {
//         if (evt.key === "Escape") {
//             var $openDropdown = $('.nav-item.dropdown.open');
//             var $openSubmenu = $('.sub-nav-item.open');

//             if ($openDropdown.length) {
//                 closeDropdown($openDropdown);
//             }

//             if ($openSubmenu.length) {
//                 closeSubDropdown($openSubmenu);
//             }
//         }
//     });
// });





$(document).ready(function () {
    // Check for the image and assign alt text
    var checkImage = setInterval(function () {
        var image = $(".shipsell-img-wrapper img");
        if (image.length) {
            image.attr("alt", "");
            clearInterval(checkImage);
        }
    }, 500);

    // Handle main dropdown toggle click
    $('.main-nav').on('click', '.nav-item.dropdown > .nav-item-link', function (evt) {
        evt.preventDefault();
        var $dropdownContainer = $(this).parent();
        toggleDropdown($dropdownContainer);
    });

    // Handle submenu item toggle click
    $('.main-nav').on('click', '.sub-nav-item > .sub-nav-item-link', function (evt) {
        var $submenuContainer = $(this).parent();
        if ($submenuContainer.find('.sub-sub-nav-list').length) {
            evt.preventDefault();
            toggleSubDropdown($submenuContainer);
        } else {
            window.location.href = $(this).attr('href');
        }
    });

    // Handle icon click to toggle main dropdown
    $('.main-nav').on('click', '.nav-item.dropdown .svg-chevron-down', function (evt) {
        evt.preventDefault();
        var $dropdownContainer = $(this).closest('.nav-item.dropdown');
        toggleDropdown($dropdownContainer);
    });

    // Keyboard navigation for dropdowns
    $('.main-nav').on('keydown', '.nav-item.dropdown > .nav-item-link, .sub-nav-item > .sub-nav-item-link', function (evt) {
        if (evt.which === 32 || evt.which === 13) { // Space or Enter key
            evt.preventDefault();
            $(this).click();
        }
    });

    // Toggle main dropdown
    function toggleDropdown($dropdownContainer) {
        var isOpen = $dropdownContainer.hasClass('open');

        // Close other open dropdowns
        $('.nav-item.dropdown').not($dropdownContainer).removeClass('open')
            .children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();

        if (isOpen) {
            closeDropdown($dropdownContainer);
        } else {
            openDropdown($dropdownContainer);
        }
    }

    function openDropdown($dropdownContainer) {
        $dropdownContainer.addClass('open');
        $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'true').next('.sub-nav').show();
    }

    function closeDropdown($dropdownContainer) {
        $dropdownContainer.removeClass('open');
        $dropdownContainer.children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-nav').hide();
    }

    // Toggle submenu dropdown, ensuring only one submenu is open at a time
    function toggleSubDropdown($submenuContainer) {
        var isOpen = $submenuContainer.hasClass('open');

        // Close other open submenus
        $('.sub-nav-item').not($submenuContainer).removeClass('open')
            .children('[aria-expanded]').attr('aria-expanded', 'false').next('.sub-sub-nav-list').hide();

        if (isOpen) {
            closeSubDropdown($submenuContainer);
        } else {
            openSubDropdown($submenuContainer);
        }
    }

    function openSubDropdown($submenuContainer) {
        $submenuContainer.addClass('open');
        $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'true');
        $submenuContainer.find('.sub-sub-nav-list').show();
    }

    function closeSubDropdown($submenuContainer) {
        $submenuContainer.removeClass('open');
        $submenuContainer.children('[aria-expanded]').attr('aria-expanded', 'false');
        $submenuContainer.find('.sub-sub-nav-list').hide();
    }

    // Close dropdowns on Escape key, retaining proper state
    $(document).on('keydown', function (evt) {
        if (evt.key === "Escape") {
            var $openDropdown = $('.nav-item.dropdown.open');
            var $openSubmenu = $('.sub-nav-item.open');

            if ($openDropdown.length) {
                closeDropdown($openDropdown);
            }

            if ($openSubmenu.length) {
                closeSubDropdown($openSubmenu);
            }
        }
    });
});
















// $(document).ready(() => {
//     $(".shipsell-img-wrapper img").attr("alt", "Free Shipping icon");
// });




$(function() {
    // Select only the <a> link with the specific href for the accessibility page
    const link = $('ul.plain li a[href="/pages/accessibility-statement"]');

    // Check if the link exists and is the last child of its parent <li>
    if (link.length > 0 && link.parent('li').is(':last-child')) {
        link.attr('id', 'accessibility-statement'); // Add the ID only to the correct <a> link
        console.log('Accessibility link found and ID added:', link); // Debugging message
    } else {
        console.log('Accessibility link not found or is not the last child.');
    }
});




$(document).ready(function () {
    // Toggle cart popup
    $('.toggle-cart-summary').on('click', function (e) {
        e.preventDefault();
        const cartSummary = $('#cart-summary');
        const isOpen = cartSummary.hasClass('is-open');
  
        // Toggle the class
        cartSummary.toggleClass('is-open');
  
        // Update ARIA attributes
        if (isOpen) {
            // If it was open, now close it
            cartSummary.attr('aria-hidden', 'true');
            $(this).attr('aria-expanded', 'false');
  
            // Announce that the cart is collapsed
            $('#announce').text('Cart collapsed.');
        } else {
            // If it was closed, now open it
            cartSummary.attr('aria-hidden', 'false');
            $(this).attr('aria-expanded', 'true');
  
            // Announce that the cart is expanded
            $('#announce').text('Cart expanded.');
        }
    });
  });
  




  $(document).ready(function() {
    const filterToggle = $('.cc-toolbar-filter-toggle');
    const filterOptions = $('#filter-options');
  
    filterToggle.on('click', function(e) {
      e.preventDefault();
      const isExpanded = filterToggle.attr('aria-expanded') === 'true';
  
      // Toggle aria-expanded and aria-hidden states
      filterToggle.attr('aria-expanded', !isExpanded);
      filterOptions.attr('aria-hidden', isExpanded);
  
      // Set focus to the first interactive element in the expanded filter options if expanded
      if (!isExpanded) {
        filterOptions.find('select, input, button').first().focus();
      } else {
        // Set focus back to the toggle button when collapsed
        filterToggle.focus();
      }
    });
  });

  
//accordian summy collaps state
document.querySelectorAll('.cc-accordion-item').forEach((details) => {
    const summary = details.querySelector('.cc-accordion-item__title');
    const icon = summary.querySelector('.toggle-icon');
  
    // Function to update aria-expanded and icon on open/close state
    function updateAriaState() {
      const isOpen = details.hasAttribute('open');
      details.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      icon.textContent = isOpen ? '-' : '+'; // Update the icon
    }
  
    // Initial state setup
    updateAriaState();
  
    // Update state on toggle
    details.addEventListener('toggle', updateAriaState);
  });


// document.querySelectorAll('.cc-accordion-item').forEach((details) => {
//     const summary = details.querySelector('.cc-accordion-item__title');
//     const icon = summary.querySelector('.toggle-icon');
  
//     // Function to update the aria-expanded state and icon
//     function updateAriaState(isOpen) {
//       summary.setAttribute('aria-expanded', isOpen);
//       icon.textContent = isOpen ? '-' : '+'; // Update the icon
//     }
  
//     // Set initial aria-expanded state
//     updateAriaState(details.hasAttribute('open'));
  
//     // Update state on toggle
//     details.addEventListener('toggle', () => {
//       const isOpen = details.hasAttribute('open');
//       updateAriaState(isOpen);
      
//       // Give the screen reader time to update the state
//       setTimeout(() => {
//         const message = isOpen ? 'collapsed' : 'expanded';
//         summary.textContent = `${title} ${message}`;
//       }, 0);
//     });
//   });

$(document).ready(function() {
    // Create an interval to check for the image every 500 milliseconds
    var checkImage = setInterval(function() {
        var image = $(".shipsell-img-wrapper img");
        
        // If the image is found, assign the alt attribute and clear the interval
        if (image.length) {
            image.attr("alt", "Truck icon for shipping");
            image.attr('aria-hidden','true');
            clearInterval(checkImage); // Stop checking once the image is found and alt is assigned
        }
    }, 500); // Check every 500ms (can adjust the interval as needed)
});


document.querySelectorAll('.nav-item.dropdown.drop-norm .nav-item-link[role="button"][tabindex="0"]').forEach(function(anchor) {
    anchor.removeAttribute('href');
    anchor.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default action (link navigation)
        // Your custom navigation logic here
        console.log("Nav item link with role button and tabindex 0 clicked, but href is removed.");
    });
});

document.querySelectorAll('.zd.sub-nav-item.has-dropdown .sub-nav-item-link[role="button"][tabindex="0"]').forEach(function(anchor) {
    anchor.removeAttribute('href');
    anchor.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default action (link navigation)
        // Your custom navigation logic here
        console.log("Sub-nav item link with role button and tabindex 0 clicked, but href is removed.");
    });
});


  

// var lastFocusedButton;

// // Show the popup and set focus on the h3 element inside it
// $(".classname").on("click", function () {
//   lastFocusedButton = $(this); // Save the last focused button
//   setTimeout(function () {
//     $(".classname").attr("tabindex", 0).focus();
//   }, 1000);
// });

// // Close the popup and return focus to the last focused button
// $(".classname").on("click", function () {
//   setTimeout(function () {
//     if (lastFocusedButton) {
//       lastFocusedButton.attr("tabindex", 0).focus();
//     }
//   }, 1000);
// });

$(document).ready(function() {
    $('button.btn.shogun-form-submit').on('click', function(event) {
        // Prevent default action if needed
        event.preventDefault();

        // Add a delay to allow the style attribute to update
        setTimeout(function() {
            // Remove tabindex from all hidden error containers
            $('.shogun-form-error').filter(function() {
                return $(this).css('display') === 'none';
            }).removeAttr('tabindex');

            // Find the first error message container with display: inline
            const errorContainer = $('.shogun-form-error').filter(function() {
                return $(this).css('display') === 'inline';
            }).first();

            if (errorContainer.length) {
                // If a visible error container is found, move focus to the input above it
                const inputField = errorContainer.prev('input, textarea, select');
                if (inputField.length) {
                    inputField.focus();
                } else {
                    console.log('No input field found above the error container.');
                }

                // Add tabindex if not already present
                errorContainer.attr('tabindex', '-1');
            } else {
                // If no error container is visible, process the success message
                const successMessage = $('.shogun-success-alert');
                if (successMessage.length) {
                    // Add role and aria-live for accessibility
                    successMessage.attr({
                        'role': 'alert',
                        'aria-live': 'polite',
                        'tabindex': '-1' // Ensure focusability
                    });
                    successMessage.focus();
                } else {
                    console.log('No success message found.');
                }
            }
        }, 50); // Delay of 50ms to allow style updates
    });
});

  


  // Function to update focusable elements in aria-hidden containers
  function fixAriaHiddenElements() {
    // Select all elements with aria-hidden="true"
    const hiddenContainers = document.querySelectorAll('[aria-hidden="true"]');

    hiddenContainers.forEach(container => {
      // Find all focusable elements inside the container
      const focusableElements = container.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');
      
      // Disable focus for all focusable elements
      focusableElements.forEach(element => {
        element.setAttribute('tabindex', '-1');
        element.setAttribute('aria-hidden', 'true');
      });
    });
  }

  // Run the function initially and whenever the DOM updates
  const observer = new MutationObserver(() => {
    fixAriaHiddenElements();
  });

  // Observe the entire document for changes
  observer.observe(document.body, { childList: true, subtree: true });

  // Initial run
  fixAriaHiddenElements();

  const addAltText = () => {
      const imgElement = document.getElementById('ellhp');
      if (imgElement) {
          imgElement.setAttribute('alt', 'Tracking pixel for GoSports page view analytics.');
          console.log('Alt text added.');
          clearInterval(checkExist);
      }
  };

  // Keep checking for up to 10 seconds
  const checkExist = setInterval(addAltText, 500);
  setTimeout(() => clearInterval(checkExist), 10000); // Stop after 10 seconds
